import { render, staticRenderFns } from "./TheMagicOfFermentation.vue?vue&type=template&id=7b8ba3b5&scoped=true"
import script from "./TheMagicOfFermentation.vue?vue&type=script&lang=js"
export * from "./TheMagicOfFermentation.vue?vue&type=script&lang=js"
import style0 from "./TheMagicOfFermentation.vue?vue&type=style&index=0&id=7b8ba3b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8ba3b5",
  null
  
)

export default component.exports